var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "vector",
    _vm._b(
      {
        style: { fill: _vm.defaultColor },
        attrs: { "show-viewbox": true },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function() {
              return [
                _vm.layers
                  ? _c(
                      "g",
                      [
                        _c("layer", {
                          attrs: {
                            position: _vm.layers["head3"],
                            layer: _vm.layers["head3"]
                          }
                        }),
                        _c("layer", {
                          attrs: {
                            position: _vm.layers["body2"],
                            layer: _vm.layers["body2"]
                          }
                        }),
                        _c(
                          "layer",
                          {
                            attrs: {
                              position: _vm.layers["rightshoulder"],
                              layer: _vm.layers["rightshoulder"]
                            }
                          },
                          [
                            _c("layer", {
                              attrs: {
                                position: _vm.layers["rightarm"],
                                layer: _vm.layers["rightarm"]
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "layer",
                          {
                            attrs: {
                              position: _vm.layers["leftshoulder"],
                              layer: _vm.layers["leftshoulder"]
                            }
                          },
                          [
                            _c("layer", {
                              attrs: {
                                position: _vm.layers["leftarm"],
                                layer: _vm.layers["leftarm"]
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "layer",
                          {
                            attrs: {
                              position: _vm.layers["leftleg"],
                              layer: _vm.layers["leftleg"]
                            }
                          },
                          [
                            _c("layer", {
                              attrs: {
                                position: _vm.layers["leftcalf"],
                                layer: _vm.layers["leftcalf"]
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "layer",
                          {
                            attrs: {
                              position: _vm.layers["rightleg"],
                              layer: _vm.layers["rightleg"]
                            }
                          },
                          [
                            _c("layer", {
                              attrs: {
                                position: _vm.layers["rightcalf"],
                                layer: _vm.layers["rightcalf"]
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e()
              ]
            },
            proxy: true
          }
        ])
      },
      "vector",
      _vm.$props,
      false
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }